import { useTranslation } from 'react-i18next'
import { JobcardStatus, STATUS_LABELS } from '@garage/shared'
import { StatusDot, type Tone } from '@/ui'

interface StatusChipProps {
  status: JobcardStatus
}

/**
 * Every jobcard status's colour, in one place — exported so anything else
 * colouring a jobcard by status (the calendar's appointment chips, for one)
 * reads the same mapping instead of keeping its own copy that can drift the
 * next time a status is added.
 */
export const JOBCARD_STATUS_TONE: Record<JobcardStatus, Tone> = {
  draft: 'neutral',
  awaiting_approval: 'warning',
  in_progress: 'info',
  completed: 'teal',
  invoiced: 'violet',
  paid: 'success',
  cancelled: 'error',
}

/**
 * Maps a JobcardStatus to a StatusDot with the appropriate tone and a
 * translated label. STATUS_LABELS (the state machine's own English copy)
 * is passed as the i18n default, so a status added there works immediately
 * even before its Arabic translation exists.
 */
export function StatusChip({ status }: StatusChipProps) {
  const { t } = useTranslation()
  return (
    <StatusDot
      tone={JOBCARD_STATUS_TONE[status]}
      label={t(`status.${status}`, STATUS_LABELS[status])}
    />
  )
}
